import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads the current record after the assignment workflow completes.
 */
export const reloadRecordOnSubmitSuccess = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.currentEntityPlugin.feature.actions.getEntity
            .from(action)
            .create({}),
        ),
      ),
)
